module.exports = __webpack_public_path__ + "img/logo-kolegji.d7cdb0cd.png";